import { motion } from "framer-motion";

export const LogoMark = ({ className = "h-7", draw = false }) => {
  const p = draw
    ? { initial: { opacity: 0, scale: 0.85, filter: "blur(8px)" }, animate: { opacity: 1, scale: 1, filter: "blur(0px)" }, transition: { duration: 1.4, ease: [0.16, 1, 0.3, 1] } }
    : {};
  return (
    <motion.img
      src={draw ? "/logo-mark.png" : "/logo-mark-sm.png"}
      alt="ByteVision"
      draggable={false}
      className={`w-auto select-none ${className}`}
      {...p}
    />
  );
};

export const Logo = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <LogoMark />
    <span className="font-display text-[17px] font-bold tracking-[0.22em]">
      BYTE<span className="font-light text-[#E8C979]">VISION</span>
    </span>
  </span>
);
